import React from 'react'
import { FaArrowRight, FaStar } from 'react-icons/fa'
function WD_Review_Program_Page() {
  return (
    <div>
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center review_component_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className=''>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp'>
                    <div className='mt-5 px-5 review_component_text'>
                        <h1 className='pt-5 display-6 review_component_text'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Abanti Mukherjee</h5>
                    <h6 class="font-weight-bold my-2">Techno India University, (BCA)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Sakshi Shrivastav</h5>
                    <h6 class="font-weight-bold my-2">Government Engineering College Patan, (CSE)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>All over this all session very useful us not only as web development but also how to work in industry.Thank you all whose provides us  this great opportunity.Thank you our mentor and InternsElite for give us this great opportunity and training.

                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Gandham Siva Sai Surya Vardhan</h5>
                    <h6 class="font-weight-bold my-2">Andhra University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>Overall Feedback about the intership is amazing i liked the way of teaching concepts and clarifying doubts and they also provided recorded classes. Helped in completion of project.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Samarth. M. Kasu</h5>
                    <h6 class="font-weight-bold my-2">Sinhgad Institute of technology, Lonavl, IT</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>This internship program was a valuable learning experience. The structure of the program was commendable, with involvement of various projects. The mentorship provided was exceptional, and helped me a lot in my development.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Rohit Rajendra Gaikwad</h5>
                    <h6 class="font-weight-bold my-2">Sinhgad Academy of engineering kondhwa, IT</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>It was amazing session taken and informative and provide with expert in specialization 
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Sana M Akhunji</h5>
                    <h6 class="font-weight-bold my-2">Sankalchand Patel College of Eng., CE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>I had a fantastic experience with Internselite during my web development traineeship. The instructors were highly knowledgeable, patient, and approachable.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default WD_Review_Program_Page
